<template lang="html">
	<div id="main" class="content">
		<div class="container">
			<article itemscope="itemscope">
				<div class="posts-list js-posts">
					<div class="post post-layout-list" data-aos="fade-up" v-for="article in articles" @click="detail(article.id)">
						<div class="status_list_item icon_kyubo">
							<div class="status_user" style="background-image: url(../../static/images/b0ce3f3cde0c084b6d42321b2dcbc407.jpeg);">
								<div class="status_section">
									<div class="status_btn">{{article.title}}</div>
                                    <div class="review-item-creator">{{article.date}}</div>
									<p class="section_p" v-html="article.desc" style="-webkit-box-orient: vertical;"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- post-formats end Infinite Scroll star -->
				<!-- post-formats -->
				<div class="pagination js-pagination" v-if="hasNext">
					<div class="pagination__load">
						<div @click="getList" v-if="loading === false"><i class="iconfont">&#xe605;</i></div>
                        <div @click="getList" v-else  class="iconfont-loading"></div>
					</div>
				</div>
				<!-- -pagination  -->
			</article>
		</div>
	</div>
</template>
<script>
	export default {
		name: "index",
        data: function(){
            return {
                articles: [],
                params: {
                    keyword: "",
                    label_id: 0
                },
                pageInfo:{
                    totalCount: 0,    //总文章数
                    totalPage: 1,     //总页数
                },
                page: 1,     //当前页
                loading: false,    //是否正在加载
                hasNext: true      //是否有下一页
            }
        },
        created: function(){
            this.getList(this.$route);
        },
        // beforeRouteUpdate(to, from, next) {
        //     // 在当前路由改变，但是该组件被复用时调用
        //     // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
        //     // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
        //     // 可以访问组件实例 `this`
        //     if(to.query.keyWord != from.query.keyWord || to.query.label_id != from.query.label_id){
        //         this.initPage();
        //         this.getList(to);
        //     }
        //     next();
        // },
        methods: {
            detail: function(id){
                this.$router.push({name: 'Detail', params: {id}});
            },
            getList: function(route){
                this.params.keyword = route.query.keyWord ? route.query.keyWord : "";
                this.params.label_id = route.query.label_id ? route.query.label_id : 0;
                let url = "/article?p=" + this.page + "&keyword=" + this.params.keyword + "&label_id=" + this.params.label_id;
                //判断是否还有下一页
                if(!this.hasNext){
                    return false;
                }
                this.loading = true;
                this.$http.get(url, {}, (res) => {
                    if(res.status){
                        this.articles = this.page == 1 ? res.data : this.articles.concat(res.data);
                        this.pageInfo = res.page_info;
                        this.page++;
                        //判断是否还有下一页
                        if(this.page > this.pageInfo.totalPage){
                            //隐藏分页按钮
                            this.hasNext = false;
                        }
                    }else{
                        console.log(res.msg);
                    }
                    this.loading = false;
                })
            },
            initPage: function(){
                this.page = 1;
                this.hasNext = true;
                this.loading = false;
            }
        }
	}
</script>
<style lang="css" scoped>
    .review-item-creator {
        font-size:0.9em;
    }
    .section_p {
        display: -webkit-box;
        -webkit-line-clamp: 5;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue